export default __webpack_public_path__ + "static/media/HOT-MOP-SHOWER-PAN.986b9089.jpg";